import { render, staticRenderFns } from "./IntendCollect.vue?vue&type=template&id=7bf23bd0&scoped=true"
import script from "./IntendCollect.vue?vue&type=script&lang=js"
export * from "./IntendCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf23bd0",
  null
  
)

export default component.exports